import React, { createContext, useCallback, useContext, useState } from "react";

interface DumontPanelContextValue {
  isPanelOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;
}

const DumontPanelContext = createContext<DumontPanelContextValue | null>(null);

export function DumontPanelProvider({ children }: { children: React.ReactNode }) {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const openPanel = useCallback(() => setIsPanelOpen(true), []);
  const closePanel = useCallback(() => setIsPanelOpen(false), []);

  const value: DumontPanelContextValue = {
    isPanelOpen,
    openPanel,
    closePanel,
  };

  return (
    <DumontPanelContext.Provider value={value}>
      {children}
    </DumontPanelContext.Provider>
  );
}

export function useDumontPanel(): DumontPanelContextValue {
  const ctx = useContext(DumontPanelContext);
  if (!ctx) {
    throw new Error("useDumontPanel must be used within DumontPanelProvider");
  }
  return ctx;
}